import firebase from 'firebase/app';
import 'firebase/messaging';
import {commonService} from "@/services/common";

export function initializeFirebase() {
  if (firebase.messaging.isSupported()) {
    // Initialize Firebase
    const firebaseConfig = {
      apiKey: "AIzaSyCkjJQjNd9_D3dLR8VmLoDWqkZgjuqkGZw",
      authDomain: "ipos-dms.firebaseapp.com",
      projectId: "ipos-dms",
      storageBucket: "ipos-dms.appspot.com",
      messagingSenderId: "848792023015",
      appId: "1:848792023015:web:656a1a1953a5efc6b8d742",
      measurementId: "G-W3MVX9BGSL"
    };
    const pushCert = "BLQNW_1gL5DaG3MnL1E8gIaBjWdYD15_rT5iJ7BIzEeNfP7B0bRgRXL_EI9QF_XKB8Zq0CtWdkf0wc_rud_NR1Y";

    firebase.initializeApp(firebaseConfig);

    // Retrieve Firebase Messaging object.
    const messaging = firebase.messaging();
    messaging.getToken({vapidKey: pushCert}).then(async (currentToken) => {
      if (currentToken) {
        console.log('Notification permission granted.');
        console.log(currentToken);
        localStorage.setItem('fTk', currentToken);
        if (localStorage.getItem('user')) {
          await commonService.registerFirebase(
            {
              "device_type": "WEB",
              "registration_id": currentToken
            }
          );
        }
      } else {
        console.log('No registration token available. Request permission to generate one.');
      }
    }).catch((err) => {
      console.log('Unable to get permission to notify.', err);
    });
  }
}